module.exports = __webpack_public_path__ + "img/user08.1ffcc294.jpg";